import React from 'react';
import { connect } from 'react-redux';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { withTranslation, WithTranslation } from 'react-i18next';
import { match } from 'react-router-dom';

// Components
import App from '../../../components/app';
import ErrorMessage from '../../../components/error-message';
import EnhancedForm from '../../../components/form';
import { FormDatas } from '../../../local-types';
// Modules
import { selectors as errorsSelectors, ErrorPayload } from '../../../redux/reducers/errors';
import { actions as companyActions, types as companyTypes } from '../../../redux/reducers/companies';
import { selectors as pendingSelectors } from '../../../redux/reducers/pendingOperations';
// Ressources
import styles from './company-department-add-style';
import { AccountRight, RightRank } from '../../../utils/userUtils';
import { paths } from '../../paths';
import { TParams } from '../../../redux/reducers/api-types';

interface CompanyAddProps extends WithTranslation, WithStyles {
    match: match<TParams>;
    saveDepartment: (id, payload) => any;
    getSaveDepartmentError: ErrorPayload;
    isSavingDepartment: boolean;
}

interface State {
    formData: any;
}

class CompanyAddDepartmentPage extends React.Component<CompanyAddProps, State> {
    inputs: FormDatas[];

    constructor(props: CompanyAddProps) {
        super(props);
        const { t, match } = props;
        const id = match.params.id;
        this.state = {
            formData: {
                partner_id: id,
                name: '',
            },
        };

        this.inputs = [
            {
                title: t('add_department.title'),
                datas: [{ id: 'name', label: t('common:form.lastname'), required: true }],
            },
        ];
    }

    handleSubmit = (formData, event): void => {
        const { saveDepartment, match } = this.props;
        const id = match.params.id;
        this.setState({ formData: formData });
        saveDepartment(id, formData);
    };

    render() {
        const { getSaveDepartmentError, isSavingDepartment, match } = this.props;
        const id = match.params.id;

        const formPayload = this.state.formData;

        return (
            <App needRights={{ name: AccountRight.COMPANY_SETTINGS, mode: RightRank.W }}>
                <ErrorMessage payload={getSaveDepartmentError} />
                {this.inputs && (
                    <EnhancedForm
                        payload={formPayload}
                        inputs={this.inputs}
                        backRoute={`${paths.companies}/${id}`}
                        onSubmit={this.handleSubmit}
                        loader={isSavingDepartment}
                    />
                )}
            </App>
        );
    }
}

const CompanyAddDepartmentPageWithStyleAndTranslation = withStyles(styles)(
    withTranslation(['company', 'common'])(CompanyAddDepartmentPage),
);

const mapStateToProps = (state) => ({
    getSaveDepartmentError: errorsSelectors.getSaveDepartmentError(state),
    isSavingDepartment: pendingSelectors.isPending(state, companyTypes.SAVE_COMPANY_DEPARTMENT),
});

const mapDispatchToProps = {
    saveDepartment: companyActions.saveDepartment,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyAddDepartmentPageWithStyleAndTranslation);
